import { render, staticRenderFns } from "./noticeitem.vue?vue&type=template&id=8ee22c2a&scoped=true&"
import script from "./noticeitem.vue?vue&type=script&lang=js&"
export * from "./noticeitem.vue?vue&type=script&lang=js&"
import style0 from "./noticeitem.vue?vue&type=style&index=0&id=8ee22c2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee22c2a",
  null
  
)

export default component.exports